import { render } from "./RadioGroup.vue?vue&type=template&id=1c3e4253"
import script from "./RadioGroup.vue?vue&type=script&lang=js"
export * from "./RadioGroup.vue?vue&type=script&lang=js"

import "./RadioGroup.vue?vue&type=style&index=0&id=1c3e4253&lang=scss"
script.render = render

export default script